<template>
  <main class="content">
    <section class="return">
      <div class='container'>
        <div class="return__wrapper">
          <h3 class="return__titile">
            {{article.name}}
          </h3>
          <!--div class="return__nav">
            <span>от 09.07.2020</span>
            <a href="#">автоправо</a>
            <a href="#">возврат прав</a>
          </div>
          <div class="return__img">
            <picture><source srcset="assets/img/return/bg.webp" type="image/webp"><img src="assets/img/return/bg.jpg" alt="Фотография" /></picture>
          </div-->
          <div class="return__text">
            <v-runtime-template :template="article.html"/>
          </div>
        </div>
      </div>
      <!--div class="return__pagination pagination-return">
        <div class='container'>
          <div class="pagination-return__wrapper">
            <a href="#" class="pagination-return__prev">Предыдущая статья</a>
            <a href="#" class="pagination-return__next">Следующая статья</a>
          </div>
        </div>
      </div-->
    </section>
  </main>
</template>

<script>
import axios from '@/router/http'
import VRuntimeTemplate from 'v-runtime-template'
export default {
  name: 'article',
  components: {
    VRuntimeTemplate
  },
  data () {
    return {
      article: {},
      situations: []
    }
  },
  methods: {
    initPage () {
      axios.get('https://urist1.v-avtoservice.com/list/get-article?link=' + window.location.pathname).then(response => {
        this.article = response.data
        this.article.html = '<div>' + this.article.html.replace(/{showDoc}/gi, '<button class="get-doc" @click="showModal()">').replace(/{\/showDoc}/gi, '</button>') + '</div>'
      })
    },
    showModal () {
      this.$root.requestModal = 1
    }
  },
  mounted () {
    this.initPage()
  },
  watch: {
    $route (to, from) {
      this.initPage()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/article.vue